// Types
import type { TBulkActionOptionsConfigItem } from '~/modules/manager/company/users/types';
import type { TSortableHeaderItem } from '~/misc/v-table-header-sortable/types';
import { EManagerCompanyUsersBulkAction } from '~/modules/manager/company/users/types';
import { EUserSorting } from '~/misc/user-resource/types';

const BULK_ACTION_OPTIONS_CONFIG: TBulkActionOptionsConfigItem[] = [
  {
    action: EManagerCompanyUsersBulkAction.ENABLE,
    title: 'Enable all users',
  },
  {
    action: EManagerCompanyUsersBulkAction.DISABLE,
    title: 'Disable all users',
  },
  {
    action: EManagerCompanyUsersBulkAction.SUBSCRIBE_SALES,
    title: 'Subscribe all users (Sales)',
  },
  {
    action: EManagerCompanyUsersBulkAction.UNSUBSCRIBE_SALES,
    title: 'Unsubscribe all users (Sales)',
  },
  {
    action: EManagerCompanyUsersBulkAction.SUBSCRIBE_LETTINGS,
    title: 'Subscribe all users (Lettings)',
  },
  {
    action: EManagerCompanyUsersBulkAction.UNSUBSCRIBE_LETTINGS,
    title: 'Unsubscribe all users (Lettings)',
  },
];

const TABLE_HEADERS: TSortableHeaderItem[] = [
  { label: 'Email', key: EUserSorting.EMAIL, sortable: true },
  { label: 'Name', key: EUserSorting.NAME, sortable: true },
  { label: 'Areas', key: EUserSorting.AREAS, sortable: true },
  { label: 'Subscription (Sales)', key: EUserSorting.SUBSCRIBED_SALES, sortable: true },
  { label: 'Subscription (Lettings)', key: EUserSorting.SUBSCRIBED_LETTINGS, sortable: true },
  { label: 'Role', key: EUserSorting.ROLE, sortable: true },
  { label: 'Is active', key: EUserSorting.ACTIVE, sortable: true },
  { label: 'Last visit', key: EUserSorting.LAST_VISIT, sortable: true },
  { label: '', key: 'actions', sortable: false },
];

export { BULK_ACTION_OPTIONS_CONFIG, TABLE_HEADERS };
